import React, { useEffect, useState } from "react";
import DropBtn from "../modules/DropBtn";
import Button from "../modules/Button";
import "./register.scss";
import sad from "../../Assets/svg/sad.svg";
import happy from "../../Assets/svg/happy.svg";
import RadioButtons from "../modules/RadioBtn";
import tooltip from "../../Assets/svg/tooltip-icon.png";
import { LightTooltip } from "../modules/ToolTip";
import Input from "../modules/Input";
import { GetBaseUrl } from "../modules/getBaseUrl";
import Status from "../modules/Status";
import { useDispatch, useSelector } from "react-redux";
import { addBasicInfo, addCandidateInfo } from "./redux/actions";
import { api } from "../../Services";
import TransitionAlerts from "../modules/Alerts";
import Timer from "../modules/Timer";
import ModalComponent from "../modules/Modal";
import GradientLoader from "../modules/Loader";
import { useNavigate } from "react-router-dom";

function Nationality() {
  const navigate = useNavigate();

  const [aadhar, setAadhar] = useState({ value: "", otp: "" });
  const [aadharVal, setAadharVal] = useState("");
  const [valid, setValid] = useState(true);
  const [otpTxn, setOtpTxn] = useState();
  const [count, setCount] = useState(0);
  const [btn, setBtn] = useState(true);
  const [err, setErr] = useState("");
  const [timeRemaining, setTimeRemaining] = useState(10);
  const [otpCount, setOtpCount] = useState(0);
  const [alert, setAlert] = useState(false);
  const [alertType, setAlertType] = useState({ msg: "", type: "" });

  const [type, setType] = useState("regular");
  const [indian, isIndian] = useState("true");
  const dispatch = useDispatch();
  const registeredData = useSelector((state) => state.register.registeredData);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const toolTipData =
    "Family members include parents, spouses, children, siblings and grandparents. The relationships are created via blood, adoption, and marriage.";
  const sadText = () => {
    return (
      <>
        <div className="sad-text"> 
          {type === "happy" ? (
            `You are eligible for IDFC FIRST Bank ${registeredData?.info?.course.includes('Engineering') ? 'Engineering':"MBA"}  Scholarship Program for  ${registeredData?.info?.course.includes('Engineering') ? '2024-2028':"2024-2026"}.`
          ) : (
            <>
              <img className="tooltip-icon" src={tooltip} alt="tooltip" />
              Only Indian students residing in India are eligible.
            </>
          )}
        </div>
        <div className="sad-text">
          {type === "happy" ? (
            "Let’s get you signed up."
          ) : (
            <>
              <img className="tooltip-icon" src={tooltip} alt="tooltip" />
              Your Aadhaar records show that you were found ineligible earlier
            </>
          )}
        </div>
      </>
    );
  };

  const getBtnDisable = () => {
    let isDisable = true;
    if (indian === "false") {
      isDisable = false;
    } else if (type === "otp" && aadhar?.otp?.length === 6) {
      isDisable = false;
    } else if (aadhar?.value?.length === 12) {
      isDisable = false;
    }
    // console.log("in disble", isDisable, aadhar !== "", valid === true);
    setBtn(isDisable);
  };

  const convertJsonToBase64 = (json) => {
    // Step 1: Convert JSON object to string
    const jsonString = JSON.stringify(json);

    // Step 2: Convert string to Base64
    const base64String = btoa(jsonString);

    return base64String;
  };
  const checkAadhar = async () => {
    setIsLoading(true);
    let aadharValue = convertJsonToBase64({ "uid": `${registeredData?.info?.aadhaar}`, "rc": "Y" })
    

    try {
      const users = await api.invokeAdhaarOtp(aadharValue);
      console.log(users);
      if (users?.data?.metadata?.status === "ERROR") {
        setErr(users.data.metadata.message);
        setTimeout(() => setErr(""), 5000);
        // setAlertType({ msg: users.data.metadata.message, type: "otp" });
        // setAlert(true);
        // //remove this line
        // setOtpTxn("1234");
        // setType("otp"); //remove this line
        // setCount(0); //remove this line
      } else if (users?.statusCode == "500") {
        if(users.data && typeof users.data === 'string' ){

          setErr(users.data);
        }
        setTimeout(() => setErr(""), 3000);
      } else {
        setAlertType({
          msg: users?.data?.metadata?.message,
          type: "otp",
        });
        dispatch(addCandidateInfo(["arn", users.data.arn]));
        setOtpTxn(users.data.resource_data[0].otpTxn);
        setAlert(true);
        setTimeout(() => setAlert(false), 3000);
        setType("otp");
        setCount(0);
      }
    } catch (error) {
      // setOtpTxn("1234");
      // setType("otp"); //remove this line
      // setCount(0);
      if(error.data && typeof error.data === 'string' ){

        setErr(error.data);
      } else {
        setErr(
          "Aadhar Service not available, Please connect with the administrator"
        );
      }
      console.error("Error invoking Aadhaar OTP:", error);
      setTimeout(() => setErr(""), 3000);
      // Handle error scenario
    } finally {
      setIsLoading(false);
    }
  };

  const verifyAadhar = async () => {
    setIsLoading(true);
    setOtpCount((prev) => prev + 1);
    let aadharOTP = convertJsonToBase64({
      "uid": registeredData?.info?.aadhaar,
      "pfr": "N",
      "otp": aadhar.otp,
      "otpTxn": otpTxn,
    });

    try {
      let users = await api.verifyAdhaarOtp(aadharOTP);
      if (users.statusCode == 200) {
        if (users.data.metadata.status === "ERROR") {
          if (users.data.metadata.code === "E-149") {
            // setAlertType({
            //   msg: "This Aadhaar number doesn’t exist. Please try again.",
            //   type: "otp",
            // });
            setErr("This Aadhaar number doesn’t exist. Please try again.");
            setTimeout(() => setErr(""), 5000);
            // setErr(
            //   "This Aadhaar number doesn’t exist. Please try again."
            // );
            // setAlert(true);

            setTimeout(() => setAlert(false), 3000);
          } else {
            setAlertType({ msg: users.data.metadata.message, type: "otp" });
            setAlert(true);
          }
        } else {
          delete users.data.metadata;
          // const { salesForcePersonalInfoId, ...userData } = users.data;
          dispatch(addBasicInfo(users.data));
          setType("happy");
        }
      }
    } catch (error) {
      // const { salesForcePersonalInfoId, ...userData } = JSON.parse(
      //   '{"firstName":"Amitkumar Joshi","photo":"","mobile":"","email":"abc@anc.com","experience":"Less than 6 months","gender":"Male","dob":"2017-01-06","status":null,"address":[{"salesForceAddressId":null,"address1":"rampura","address2":"ward no 10","city":"Nathdwara","state":"Rajasthan","pin":"313301","addressProof":"aadhaar","addressType":"PERMANENT"}]}'
      // );
      // dispatch(addBasicInfo(userData));
      // setType("happy");
      console.error("Error verifying Aadhaar OTP:", error);
      // Handle error scenario
    } finally {
      setIsLoading(false);
    }
  };

  const nextPage = async () => {
    if (type === "regular") {
      if (
        registeredData?.info?.indian !== "" &&
        !registeredData?.info?.indian
      ) {
        setType("sad");
      } else if (registeredData?.info?.indian) {
        await checkAadhar();
      }
    } else if (type === "otp") {
      if (otpCount < 3) {
        await verifyAadhar();
      } else {
        setLoading(true);

        setTimeout(() => {
          setType("regular");
          setLoading(false);
        }, 3000);
      }
    } else if (type === "happy") {
      let url = GetBaseUrl(window.location.href);
      // window.location.replace(url + "/signup/mobile");
      navigate("/signup/mobile");

    } else {
      let url = GetBaseUrl(window.location.href);
      // window.location.replace(url);
      navigate('/');

    }
  };
  const doResendOtp = () => {
    checkAadhar();
    setTimeRemaining(10);
  };
  const resendText = () => {
    return (
      <div className="edit-text">
        <span
          className={`left-edit ${timeRemaining > 0 ? "disabled-text" : ""} `}
          onClick={() => doResendOtp()}
        >
          Resend OTP{" "}
        </span>
        {timeRemaining > 0 && (
          <span className="pointer right-edit">
            00:
            {<Timer isTime={(e) => setTimeRemaining(e)} time={timeRemaining} />}
          </span>
        )}
      </div>
    );
  };

  const reject = () => {
    setBtn(false);
    setType("sad");
  };

  const filterInput = (data) => {
    if (type === "regular") {
      data = data.replace(/\D/g, "");
      if (data?.length > 11) {
        data = data?.slice(0, 12);
        setValid(true);
      } else {
        setValid(false);
      }
      dispatch(addCandidateInfo(["aadhaar", data]));
      // setAadhar({ ...aadhar, value: data });
      setAadharVal(data);
    } else {
      data = data.replace(/\D/g, "");
      if (data?.length > 5) {
        data = data.slice(0, 6);
        setValid(true);
        setBtn(false);
        // isError = false;
      } else {
        setValid(false);
      }
      setAadhar({ ...aadhar, otp: data, value: "" });
    }
  };

  const dispatchData = (type, e) => {
    dispatch(addCandidateInfo([type, e]));
  };

  useEffect(() => {
    let newCount = 0;
    let total = registeredData?.info?.indian ? 2 : 1;
    if (registeredData?.info?.indian !== "") {
      newCount += 1;
    }
    if (registeredData?.info?.aadhaar?.length === 12) {
      newCount += 1;
    }
    console.log(
      "registeredData?.info?.indian",
      registeredData?.info,
      total,
      newCount
    );
    newCount = Math.abs((newCount / total) * 100);
    setCount(newCount);
    setBtn(true);
    getBtnDisable();
    // console.log("count", newCount);
  }, [registeredData]);

  useEffect(() => {
    if (type === "otp" && aadhar?.otp?.length === 6) {
      setCount(100);
    }
  }, [aadhar]);
  console.log("aadhar value", aadhar);
  return (
    <div className={`cred-section income nationality-page ${type}`}>
      {type === "sad" ? (
        <img className="sad" src={sad} alt="sad" />
      ) : type === "happy" ? (
        <img className="sad" src={happy} alt="happy" />
      ) : (
        ""
      )}
      <span className="title">
        {type === "sad"
          ? "Sorry! You are not eligible."
          : type === "happy"
          ? `Congratulations, ${registeredData?.basicInfo?.firstName}!`
          : "Nationality"}
      </span>
      <span className="sub-title">
        {type === "sad"
          ? sadText()
          : type === "happy"
          ? sadText()
          : "Verify your nationality"}
      </span>
      {(type === "otp" || type === "regular") && <Status count={count} />}
      {(type === "regular" || type === "otp") && (
        <div
          className={`cred-fields ${
            registeredData?.info?.indian === true ? "isIndian" : ""
          }`}
        >
          {type === "regular" && (
            <div className="radio-item">
              <span className="radio-title">
                Are you an Indian national residing in India?
              </span>
              <div className="radio-options">
                <div className="radio-option sub-option-text">
                  <RadioButtons
                    onChange={() => dispatchData("indian", true)}
                    value={
                      registeredData?.info?.indian === ""
                        ? ""
                        : registeredData?.info?.indian
                        ? "true"
                        : "false"
                    }
                    option={"true"}
                    disabled={isLoading}
                  />
                  Yes
                </div>
                <div className="radio-option sub-option-text">
                  <RadioButtons
                    onChange={() => dispatchData("indian", false)}
                    value={
                      registeredData?.info?.indian === ""
                        ? ""
                        : registeredData?.info?.indian
                        ? "true"
                        : "false"
                    }
                    option={"false"}
                    disabled={isLoading}
                  />
                  No
                </div>
              </div>
            </div>
          )}
          {registeredData?.info?.indian === true && (
            <>
              {/* {type === "regular" ? ( */}
              <Input
                placeholder={
                  type === "regular"
                    ? "Aadhaar Number"
                    : "Enter Aadhaar OTP sent to your mobile"
                }
                // setValid={(e) => setValid(e)}
                type="password"
                onChange={(e) => filterInput(e)}
                value={
                  type === "regular" ? registeredData.info.aadhaar : aadhar.otp
                }
                id={"aadhar"}
                disabled={isLoading}
                // type={type === "regular" ? "password" : "password"}
              />
              {err && (
                <p className="set-sub-title" style={{ color: "red" }}>
                  {err}
                </p>
              )}
              {alertType.msg && (
                <TransitionAlerts isAlert={alert} message={alertType.msg} />
              )}
              <span className="set-sub-title">
                By entering your Aadhaar number, you are giving IDFC FIRST Bank
                consent to fetch and save Aadhaar related data.
              </span>
            </>
          )}
          {/* {(type === "regular" && registeredData?.info?.indian === true) && (
           
          )} */}
        </div>
      )}
      <div className="cred-btn">
        <Button
          disabled={
            (type === "regular" &&
              (registeredData?.info?.indian === "" || count !== 100)) ||
            (type === "otp" && aadhar?.otp?.length !== 6)
          }
          onClickHandler={() => nextPage()}
          value={
            isLoading ? (
              <div className="loading-spinner">
                {/* Add your loading spinner component or icon here */}
                <i className="fas fa-spinner fa-spin"></i>
              </div>
            ) : type === "sad" ? (
              "Back to Home"
            ) : type === "happy" ? (
              "Sign up"
            ) : (
              "Next"
            )
          }
          type={"contained"}
        />

        {registeredData?.info?.indian === true && type === "regular" && (
          <Button
            //   disabled={!value}
            onClickHandler={() => reject()}
            value={"I do not have an Aadhaar Number"}
            type={"only-text"}
            disabled={isLoading}
          />
        )}
        {type === "otp" && (
          <Button
            //   disabled={!value}
            onClickHandler={() => {}}
            value={resendText()}
            type={"only-text"}
            disabled={isLoading}
          />
        )}
      </div>
      {loading && (
        <ModalComponent
          className={"loader-model"}
          show={loading}
          // handleClose={() => CancelData()}
          // title={ModalData.title}
          // content={ModalData.desc}
        >
          <GradientLoader />
        </ModalComponent>
      )}
    </div>
  );
}

export default Nationality;
